import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FormSchedule = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FormSchedule' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M6,19 L18,19 L18,8 L6,8 L6,19 Z M8,15 L10,15 L8,15 Z M11,15 L16,15 L11,15 Z M15,8 L15,5 L15,8 Z M9,8 L9,5 L9,8 Z M6,11.5 L18,11.5 L6,11.5 Z' />
  </StyledIcon>
);
